import { TranslationService } from "../../../services/TranslationService";
import { formatCurrencyPortal } from "../../../utils/FormatUtils";
import CompanyService from "../../../services/CompanyService";
import { ConsolidatedDashboardCompany } from "../../../entities/consolidated/ConsolidatedDashboardResponse";

interface Props {
  companies: ConsolidatedDashboardCompany[];
  currencySymbol: string;
}

const ConsolidatedCompaniesList: React.FC<Props> = ({
  companies,
  currencySymbol
}) => {
  const { translate } = TranslationService;
  const showCents = CompanyService.getCompanyAuth()?.ShowCents ?? false;

  if (!companies || companies.length === 0) {
    return (
      <div className="card">
        <div className="card-body">
          <p>{translate.NoResults || "No hay resultados"}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="card-body">
        <h5 className="mb-3">
          {translate.ConsolidatedCompanies || "Empresas Consolidadas"}
        </h5>
        <div className="table-responsive">
          <table className="table table-hover">
            <thead>
              <tr>
                <th>{translate.Company || "Empresa"}</th>
                <th className="text-end">
                  {translate.Amount || "Monto Total"}
                </th>
                <th className="text-end">{translate.Dues || "Vencido"}</th>
                <th className="text-end">{translate.NoDues || "No Vencido"}</th>
              </tr>
            </thead>
            <tbody>
              {companies.map((company) => {
                const nodue = company.Amount - company.DueAmount;
                return (
                  <tr key={company.Ix}>
                    <td>{company.CompanyName}</td>
                    <td className="text-end">
                      {formatCurrencyPortal(
                        company.Amount,
                        currencySymbol,
                        showCents
                      )}
                    </td>
                    <td className="text-end text-danger">
                      {formatCurrencyPortal(
                        company.DueAmount,
                        currencySymbol,
                        showCents
                      )}
                    </td>
                    <td className="text-end text-primary">
                      {formatCurrencyPortal(nodue, currencySymbol, showCents)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ConsolidatedCompaniesList;
